import { z } from 'zod';

export const Lang = z.enum(['zh', 'en']);
export type Lang = z.infer<typeof Lang>;

/** Every piece of respondent-facing text exists in both languages; publishing with one missing is refused. */
export const L10n = z.object({
  zh: z.string().min(1),
  en: z.string().min(1),
});
export type L10n = z.infer<typeof L10n>;

/** Which questionnaire a session runs: 企业 AI 转型 (consulting) or 出海增长 (overseas). */
export const Track = z.enum(['consulting', 'overseas']);
export type Track = z.infer<typeof Track>;

export const ModuleId = z.enum(['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']);
export type ModuleId = z.infer<typeof ModuleId>;

/**
 * Stable ids: a retired question keeps its id (B2 and I2 were cut in review), so analytics line up across
 * versions. The overseas track prefixes its ids with O (OA1, OD3) so the two banks never collide in answers.
 */
export const QuestionId = z.string().regex(/^O?[A-I]\d+[a-z]?$/, 'question id like A1, A2b, OC3');
export type QuestionId = z.infer<typeof QuestionId>;

/** What a brief may cite as evidence: a question, a follow-up (FU1–FU3) or a member-check line (MC:pain). */
export const EvidenceId = z.string().regex(/^(O?[A-I]\d+[a-z]?|FU\d|MC:[a-z]+)$/, 'evidence id like C2, OE2, FU1 or MC:pain');
export type EvidenceId = z.infer<typeof EvidenceId>;

/** The module letter of a question id (OA1 -> A). */
export const moduleOf = (questionId: string): string => questionId.replace(/^O/, '')[0]!;

/** Option id the engine appends to every choice question unless allowOther is false. */
export const OTHER_ID = '__other';

export const pick = (text: L10n, lang: Lang): string => text[lang];
